module.exports = __webpack_public_path__ + "img/intro2.c9b279dc.jpg";